module.exports = __webpack_public_path__ + "img/book-fill.15cf34a7.svg";